module.exports = __webpack_public_path__ + "img/partner25.8f8b6da1.png";